export function initAccordionProgram() {
    const buttons = document.querySelectorAll<HTMLElement>('.button-program-ac');

    buttons.forEach((button) => {
        const item = button.closest<HTMLElement>('.program-accordion-item');
        const content = item?.querySelector<HTMLElement>('.program-accordion-content');

        if (!item || !content) return;

        // начальное состояние
        content.style.height = '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'height 0.3s ease';

        let isOpen = false;

        button.addEventListener('click', () => {
            if (isOpen) {
                // закрытие
                content.style.height = content.scrollHeight + 'px'; // фиксируем текущую
                requestAnimationFrame(() => {
                    content.style.height = '0px';
                });

                item.classList.remove('active');
                isOpen = false;
            } else {
                // открытие
                content.style.height = content.scrollHeight + 'px';

                item.classList.add('active');
                isOpen = true;

                // 👉 после анимации убираем фикс высоты (чтобы адаптировалось)
                const onEnd = () => {
                    content.style.height = 'auto';
                    content.removeEventListener('transitionend', onEnd);
                };

                content.addEventListener('transitionend', onEnd);
            }
        });
    });
}
